/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SalesManagerResponse
 */
export interface SalesManagerResponse {
    /**
     * 
     * @type {string}
     * @memberof SalesManagerResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SalesManagerResponse
     */
    fullname: string;
}

/**
 * Check if a given object implements the SalesManagerResponse interface.
 */
export function instanceOfSalesManagerResponse(value: object): value is SalesManagerResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullname' in value) || value['fullname'] === undefined) return false;
    return true;
}

export function SalesManagerResponseFromJSON(json: any): SalesManagerResponse {
    return SalesManagerResponseFromJSONTyped(json, false);
}

export function SalesManagerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesManagerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullname': json['fullname'],
    };
}

export function SalesManagerResponseToJSON(value?: SalesManagerResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'fullname': value['fullname'],
    };
}

